import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { vModelString } from '@/mixins/component-vmodel.js';
export default {
  name: 'd2-video-uploader',
  mixins: [vModelString],
  props: {
    width: {
      type: Number,
      default: 100,
      required: false
    },
    height: {
      type: Number,
      default: 100,
      required: false
    },
    limit: {
      type: Number,
      default: 60,
      required: false
    }
  },
  data: function data() {
    return {
      status: {
        loading: false
      }
    };
  },
  computed: {
    isEmpty: function isEmpty() {
      return !this.currentValue;
    },
    styleUploader: function styleUploader() {
      return {
        height: this.height + 'px',
        width: this.width + 'px'
      };
    },
    stylePic: function stylePic() {
      return {
        height: this.height - 2 + 'px',
        width: this.width - 2 + 'px'
      };
    },
    styleIcon: function styleIcon() {
      return {
        height: this.height - 2 + 'px',
        width: this.width - 2 + 'px',
        lineHeight: this.height - 2 + 'px'
      };
    }
  },
  methods: {
    checkLimit: function checkLimit(file) {
      var result = true;

      if (file.size > this.limit * 1024 * 1024) {
        this.$message.error("video size not over".concat(this.limit, "MB"));
        result = false;
      }

      return result;
    },
    beforeUpload: function beforeUpload(file) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var path;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.checkLimit(file)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this.status.loading = true;
                _context.prev = 3;
                _context.next = 6;
                return _this.$api.UPLOAD_VEDIO(file);

              case 6:
                path = _context.sent;
                _this.currentValue = path;

                _this.vModelMixinEmit();

                _context.next = 13;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](3);

              case 13:
                _this.status.loading = false;
                return _context.abrupt("return", false);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 11]]);
      }))();
    },
    deletePic: function deletePic() {
      this.currentValue = '';
    }
  }
};